<template>
    <div class="contact-base-content">
        <!-- Loading -->
        <loading />

        <div class="section section-form">
            <div class="section-title">
                <h2 class="heading-3">Tens alguma questão?</h2>
                <p class="color-text-body">
                    Tens alguma questão ou dúvida sobre o nosso produto? Utiliza
                    o formulário abaixo e a nossa equipa entrará em contacto
                    contigo o mais breve possivel
                </p>
            </div>

            <div class="contacts-info-wrapper">
                <div class="contact-info-item">
                    <span class="icon-phone"></span>
                    <div class="contact-item-split">
                        <span class="body-1 strong-600">234026455</span>
                        <span class="caption-md color-text-body"
                            >(chamada para rede móvel nacional)</span
                        >
                    </div>
                </div>

                <div class="contact-info-item">
                    <span class="icon-email"></span>
                    <div>
                        <span class="body-1 strong-600"
                            >geral@onliplace.com</span
                        >
                    </div>
                </div>
            </div>

            <div class="section-form-wrapper">
                <form
                    class=""
                    autocomplete="on"
                    method="post"
                    aria-describedby="Website Contact Form"
                >
                    <div class="contact-group-wrapper">
                        <div class="input-label-wrapper double-input-row">
                            <div class="flex-1">
                                <label for="firstname" class="form-label"
                                    >Primeiro nome</label
                                >
                                <input
                                    @focusin="
                                        inputValidationCase('firstname', $event)
                                    "
                                    @focusout="
                                        inputValidationCase('firstname', $event)
                                    "
                                    type="text"
                                    class="form-control"
                                    id="firstname"
                                    v-model="firstname"
                                    maxlength="150"
                                />
                            </div>
                            <div class="flex-1">
                                <label for="lastname" class="form-label"
                                    >Último nome</label
                                >
                                <input
                                    @focusin="
                                        inputValidationCase('lastname', $event)
                                    "
                                    @focusout="
                                        inputValidationCase('lastname', $event)
                                    "
                                    type="text"
                                    class="form-control"
                                    id="lastname"
                                    v-model="lastname"
                                    maxlength="150"
                                />
                            </div>
                        </div>

                        <div class="input-label-wrapper">
                            <label for="email" class="form-label">Email</label>
                            <input
                                v-model="email"
                                type="email"
                                class="form-control"
                                id="email"
                                aria-describedby="Contact Email"
                                @focusin="inputValidationCase('email', $event)"
                                @focusout="inputValidationCase('email', $event)"
                                maxlength="300"
                            />
                        </div>

                        <div class="input-label-wrapper">
                            <label for="message" class="form-label"
                                >Mensagem</label
                            >
                            <textarea
                                class="form-control"
                                @focusin="
                                    inputValidationCase('message', $event)
                                "
                                @focusout="
                                    inputValidationCase('message', $event)
                                "
                                v-model="message"
                                id="message"
                                maxlength="450"
                            >
                            </textarea>
                        </div>

                        <div class="input-label-wrapper">
                            <!-- Google recaptcha -->
                            <google-recaptcha
                                :senddata="sendData"
                                :csrftolkien="csrftolken"
                                buttontext="Enviar mensagem"
                                :recaptchurl="recaptchurl"
                                @response="recaptchaResponse($event)"
                                :existemptyvalue="checkByEmptyValues"
                                :disabled="disabled"
                            />
                        </div>
                    </div>
                </form>
            </div>

            <div class="agree-with-terms-text-wrapper">
                <p class="color-text-body">
                    Ao carregar em “enviar“ está a concordar com os nossos
                    <br />
                    <a
                        :href="termsandconditionurl"
                        target="_self"
                        aria-describedby="Terms and Conditions Link"
                        >Termos e Condições</a
                    >
                    e
                    <a
                        :href="termsandconditionurl"
                        target="_self"
                        aria-describedby="Terms and Conditions Link"
                        >Política de privicidade</a
                    >
                </p>
            </div>
        </div>

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </div>
</template>
<script>
import fetchData from "./../../fetchData.js";
import inputValidation from "./../../validationInputs.js";
import Loading from "./../elements/LoadingElement.vue";
import ListMessage from "./../elements/ListMessageElement.vue";
import responseMessage from "./../../responseMessage";
import GoogleRecaptcha from "../elements/GoogleRecaptcha.vue";

//Set Use Strict
("use strict");

export default {
    name: "Contact",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        contacturl: {
            type: String,
            required: true,
        },
        termsandconditionurl: {
            type: String,
            required: true,
        },
        recaptchurl: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            disabled: true,
            activeclass: "d-flex",
            inputNotIsValid: true,
            firstname: "",
            lastname: "",
            email: "",
            message: "",
        };
    },
    methods: {
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        inputValidationCase(inputid, element) {
            //Check Empty Values
            if (element.target.value === "") {
                return;
            }

            //Check Inputs
            switch (inputid) {
                //firstname, lastname
                case "firstname":
                case "lastname":
                    this.disabled = inputValidation.validNameCases(
                        1,
                        element.target.value,
                    )
                        ? false
                        : true;

                    break;

                //Email
                case "email":
                    this.disabled = inputValidation.validNameCases(
                        7,
                        element.target.value,
                    )
                        ? false
                        : true;

                    break;

                //message
                case "message":
                    if (this.message !== "" && this.message.length <= 400) {
                        this.disabled = inputValidation.validNameCases(
                            4,
                            this.message,
                        )
                            ? false
                            : true;
                    }

                    break;
            }

            //Set Conditional for input is valid
            this.inputNotIsValid = this.disabled;

            //Show Error Message
            if (this.disabled) {
                inputValidation.createErrorMessageElement(
                    inputid,
                    "Favor enviar dados válidos",
                );
            }
        },
        checkByEmptyValues() {
            //Check per empty values
            if (
                this.firstname === "" ||
                this.lastname === "" ||
                this.email === "" ||
                this.message === ""
            ) {
                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "Por favor enviar dados válidos",
                    this.activeclass,
                );

                //Desactive Loading
                document
                    .querySelector(".loadingbase")
                    .classList.remove("d-flex");

                return true;
            }

            return false;
        },
        sendData() {
            //Disabled Button
            this.disabled = true;

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Data Form
            let dataForm = {};

            //Set Data Form
            dataForm.firstname = this.firstname.trim();
            dataForm.lastname = this.lastname.trim();
            dataForm.email = this.email.trim();
            dataForm.message = this.message.trim();

            //Send Data
            let response = fetchData.structureTosendData(
                this.contacturl,
                dataForm,
                this.csrftolken,
                "POST",
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Add active Class
                    this.$refs.responsebasemessage.classList.add(
                        this.activeclass,
                    );
                    this.$refs.responsebasemessage.classList.add(
                        value.classname,
                    );

                    //Element for append
                    let li = responseMessage.messageStructure(
                        value.message,
                        value.classname,
                    );

                    //Append Element
                    $(li).appendTo(this.$refs.responsebasemessage.children);

                    //Remove Message
                    responseMessage.removeResponseMessages(10000);

                    //Clean Object
                    this.firstname = "";
                    this.lastname = "";
                    this.email = "";
                    this.message = "";
                })
                .catch((error) => {
                    //Enabled Button
                    this.disabled = false;

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
        recaptchaResponse(response) {
            if (!response) {
                //Clean Object
                this.firstname = "";
                this.lastname = "";
                this.email = "";
                this.message = "";

                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "Não foi possível enviar sua requisição",
                    this.activeclass,
                );
            }
        },
    },
    computed: {
        computedBtnDisabled() {
            return this.disabled;
        },
    },
    watch: {
        computedBtnDisabled() {},
    },
    components: {
        listMessage: ListMessage,
        loading: Loading,
        googleRecaptcha: GoogleRecaptcha,
    },
};
</script>
